import { Input, HostBinding, Directive, OnInit } from '@angular/core';

@Directive({
  selector: '[sukaContainer]'
})
// tslint:disable-next-line: directive-class-suffix
export class Container implements OnInit {
  @Input() sukaContainer: 'default' | 'fluid' = 'default';

  @HostBinding('class.container') default = true;
  @HostBinding('class.container--fluid') fluid = false;

  public ngOnInit() {
    if (this.sukaContainer === 'fluid') {
      this.fluid = true;
      this.default = false;
    }
  }
}
